import React from "react"
import { useTranslation } from "react-i18next"

import { Content } from "pages/dashboard/elements"
import Title from "components/ui/Title"
import Products from "components/Products/List"

const ServicesPage = () => {
  const { t } = useTranslation()

  return (
    <Content data-testid="services-page">
      <Title>{t("pages.services.title")}</Title>
      <Products />
    </Content>
  )
}

export default ServicesPage
